import React from "react";
import Toolbar, { ToolbarSchema } from "./Toolbar";
import { Editor } from "@tiptap/react";

interface Attachment {
  id: string;
  name: string;
  size?: number;
  type?: string;
  data?: Blob;
}

interface EmailToolbarProps {
  editor: Editor | null;
  onAttachmentsChange?: (attachments: Attachment[]) => void;
  schema: ToolbarSchema;
  toolbarExtraClass?: string;
}

const EmailToolbar: React.FC<EmailToolbarProps> = ({
  editor,
  onAttachmentsChange,
  schema,
  toolbarExtraClass,
}) => {
  if (!editor) return null;

  return (
    <div className="shrink-0 z-10">
      <Toolbar
        editor={editor}
        onAttachmentsChange={onAttachmentsChange}
        schema={schema}
        toolbarExtraClass={toolbarExtraClass}
      />
    </div>
  );
};

export default EmailToolbar;
